const CURRENCIES_LIST = [
  'EUR',
  'USD',
  'GBP',
  'PLN',
  'DKK',
  'NOK',
  'CZK',
  'SEK',
  'AUD',
  'CAD'
];

const DEFAULT_CURRENCY = CURRENCIES_LIST[0];

module.exports = {
  CURRENCIES_LIST,
  DEFAULT_CURRENCY
};
